import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { SsoState } from './redux';

export const ssoSelector = (state: RootState) => state.sso;

export const loadingSelector = createSelector(ssoSelector, (state: SsoState) => state.loading);
